import { isString, isBoolean } from '@app/common/utils/assertion';

export type MappedSubFields = Record<string, Record<string, any>>;

/**
 * Map subFields values to plain object.
 */
export const getMappedFields = <T extends Record<string, any>>(
  fields: Array<T | null>,
) => fields.reduce<MappedSubFields>((acc, curr) => ({
    ...acc,
    ...(curr?.id ? {
      [curr.id]: {
        ...curr,
        value: isString(curr.sValue) && isBoolean(curr.sValue)
          ? curr.sValue === 'true'
          : curr.sValue,
      },
    } : {}),
  }), {});
